const getters = {
    accommodation: state => state.accommodation,
};

export default getters;